module.exports = __webpack_public_path__ + "static/media/Barmag FK6 1000 Driven.28031b99.jpg";